import {useState} from 'react';
import {Ws} from 'app/contracts/ws';

export function useWsMessageQueue<T extends Ws.Message = Ws.Message>() {
  const [queue, setQueue] = useState<T[]>([]);

  return {queue, setQueue};
}
